import React from 'react';
import { Route } from 'react-router-dom';

import ClustersGrid from './ClustersGrid';
import ClustersForm from './ClustersForm';

/**
 * Contenedor de Clusters. La RUTA decide qué se monta (no un flag isDetail):
 *  - /Clusters            → lista (ClustersGrid)
 *  - /Clusters/:clusterId → formulario (ClustersForm); 'undefined' = nuevo
 * El `key` fuerza re-montar el form al cambiar de id (p.ej. tras crear uno nuevo).
 */
export default function Clusters(props) {
  const nivel = props.nivel;

  return (
    <>
      <Route exact path="/Clusters"
        render={() => <ClustersGrid nivel={nivel} />} />

      <Route path="/Clusters/:clusterId"
        render={({ match }) => (
          <ClustersForm
            key={match.params.clusterId}
            nivel={nivel}
            clusterId={match.params.clusterId}
          />
        )} />
    </>
  );
}
